import safeStorage from './safeStorage';

export const SUN_MODE_STORAGE_KEY = 'yona-sun-mode';

/** Forced colours / reduced transparency → leave sun filter off. */
export function shouldBlockSunModeFilter() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  try {
    if (window.matchMedia('(prefers-reduced-transparency: reduce)').matches) {
      return true;
    }
    if (window.matchMedia('(forced-colors: active)').matches) {
      return true;
    }
  } catch (_) {
    return false;
  }
  return false;
}

export function readSunModePreference() {
  try {
    return safeStorage.getItem(SUN_MODE_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeSunModePreference(enabled) {
  try {
    safeStorage.setItem(SUN_MODE_STORAGE_KEY, enabled ? '1' : '0');
  } catch (_) {
    /* ignore */
  }
}

/** Apply or clear the document-root sun-mode display filter. */
export function applySunModeToDocument(enabled) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const blocked = shouldBlockSunModeFilter();
  if (enabled && !blocked) {
    root.setAttribute('data-sun-mode', '1');
  } else {
    root.removeAttribute('data-sun-mode');
  }
  if (blocked) {
    root.setAttribute('data-sun-mode-blocked', '1');
  } else {
    root.removeAttribute('data-sun-mode-blocked');
  }
}
